module.exports = __webpack_public_path__ + "img/hot1.814895bf.png";